module.exports = __webpack_public_path__ + "static/media/water2.4bb11e32.svg";